<template>
    <span>
        <template v-for="label in labels">
            <info-label :classes="['label', `label-${labelClass(label)}`]">{{ label.text }}</info-label>
            <!-- Empty template to fix spacing -->
            <template> </template>
        </template>
    </span>
</template>

<script>
    import InfoLabel from "./InfoLabel";
    export default {
        components: { InfoLabel },
        props: ['labels'],

        methods: {
            labelClass(label) {
                return label.status || 'info';
            }
        }
    }
</script>

<style scoped>

</style>
